export enum StateTokensEnum {
  DEFAULT = "default",
  HOVER = "hover",
  FOCUS = "focus",
  DANGER = "danger",
  DISABLED = "disabled"
}
